module.exports = ".header-bold {\n  font-weight: bold; }\n\ntable {\n  border: none; }\n\n.field-bold {\n  font-style: normal;\n  font-weight: bold; }\n\n.field-italics {\n  font-style: italic;\n  font-weight: normal; }\n\n.privacy-modal {\n  height: 250px;\n  overflow-y: auto;\n  overflow-x: hidden; }\n\n@media (min-height: 500px) {\n  .privacy-modal {\n    height: 400px; } }\n\n@media (min-height: 800px) {\n  .privacy-modal {\n    height: 600px; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vendor/my-vendor/coverage-search/coverage-search.component.scss
// module id = ./src/app/pages/vendor/my-vendor/coverage-search/coverage-search.component.scss
// module chunks = main